import Core from './core'

(() => {
    try {
        // eslint-disable-next-line no-undef
        window[CONSTANTS.coreName] = Core
    } catch (ex) {
        console.error(ex)
    }
})()

// (async () => {
//     try {
//         // Salva a variável global
//         // eslint-disable-next-line no-undef
//         window[CONSTANTS.coreName] = Core

//         await Core.start()

//         // Executa imediatamente
//         Core.Tasks.add(() => {
//             // Configura a classe Config
//             Core.Config.init()

//             // Configura a classe console
//             Core.Console.init()

//             // Configura a classe Events
//             Core.Events.init()

//             // Configura a page
//             Core.Page.init()
//         })

//         Core.Tasks.add([
//             async () => {
//                 await Core.Modules.load('Lazyloading')
//                 await Core.Modules.load('Visibility')
//                 await Core.Modules.load('Alert')

//                 Core.Modules.get('Lazyloading').init()
//                 Core.Modules.get('Visibility').init()
//             },
//             () => {
//             // Carrega o Tema
//                 Core.Tasks.add(Core.Events.PAGE_LOADING, [
//                     'async#gazetadopovo-_init',
//                     () => {
//                         console.log('Tema iniciado')
//                     }
//                 ])

//                 // Carrega os modulos abstratos de UI
//                 Core.Tasks.add(Core.Events.PAGE_READY, [
//                     'async#abstracts-ui-tools',
//                     () => {
//                         console.log('Abstracts - UI-TOOLS')
//                     }
//                 ])
//             }
//         ])
//     } catch (ex) {
//         console.error(ex)
//     }
// })()

// console.log(Core);

// window.GPAbstractsCore.initialize();

// this.Events.onEntitiesFinished(['core'], () => {
//     console.log("finalizou core");
// });

// this.Events.onEntitiesFinished(['page'], () => {
//     console.log("finalizou page");
// });

// this.Page = new Page();

// this.Tasks.add({
//     'corvo': "corvo",
// })

// console.log(this.Tasks.getAll());

// this.Status.update("core" , "status" , "started");
// this.Status.update("core" , "status" , "finished");
